import { useEffect } from "react";
import { useUserPreference } from "../hooks/useUserPreferencesQuery";
import { DEFAULT_LANGUAGE, i18nInstance } from "./createi18nInstance";

const selectLanguage = (preferences: { language?: string }) =>
  preferences.language ?? DEFAULT_LANGUAGE;

/**
 * Keeps the active i18n language in sync with the user's `language` preference.
 */
export function I18nLanguageSync() {
  const language = useUserPreference(selectLanguage);

  useEffect(() => {
    if (i18nInstance.language !== language) {
      void i18nInstance.changeLanguage(language);
    }
  }, [language]);

  return null;
}
